module.exports = __webpack_public_path__ + "img/guia-tarxeta.24092df3.png";